// ----------------------------------------------------------------------
// <copyright file="Izenda.PropsEditorGuiSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import { isFunction } from 'lodash/fp';

export const createGroupSchema = (component, props, isHidden) => ({
  component,
  isHidden,
  props,
  appendChild(name, fieldSchema) {
    this.fields[name] = fieldSchema;
    return this;
  }
});

export const createPanelGroupSchema = ({
  title,
  iconClass = 'icon-toggle-triangle',
  isHidden,
  hiddenByState,
  className
}) =>
  createGroupSchema(
    'Panel',
    {
      initState: true,
      collapsible: true,
      hiddenByState,
      className,
      header: {
        get title() {
          return isFunction(title) ? title() : title;
        },
        icon: iconClass
      }
    },
    isHidden
  );

export const createFieldSchema = ({ type, component, title, info, value, props, staticProps, isHidden }) => ({
  [type ? 'type' : 'component']: type || component,
  get title() {
    return isFunction(title) ? title() : title;
  },
  get infoIcon() {
    return isFunction(info) ? info() : info;
  },
  isHidden,
  fnValue: value,
  props,
  staticProps
});

export const createDropDownSchema = ({ title, info, value, props, isHidden }) =>
  createFieldSchema({
    component: 'CustomDropdown',
    title,
    info,
    value,
    isHidden,
    props
  });

export const createPopupSettingSchema = ({ title, info, value, isHidden, props, staticProps }) =>
  createFieldSchema({
    type: 'btnPopup',
    title,
    info,
    value,
    isHidden,
    props,
    staticProps: Object.assign(
      {
        className: 'icon-setting btn-icon',
        popupProps: {
          type: 'none',
          autoClose: false,
          sizeClass: 'modal-lg',
          containerClass: 'izenda-ThresholdSettings izenda-ChartSettingsPopup'
        }
      },
      staticProps
    )
  });

export const createColorPaletteSettingSchema = ({ title, info, value, isHidden, props }) =>
  createFieldSchema({
    component: 'ColorPaletteSetting',
    title,
    info,
    value,
    isHidden,
    props
  });

export const createCheckBoxSchema = ({ title, info, value, isHidden }) =>
  createFieldSchema({
    type: 'checkbox',
    title,
    info,
    value,
    isHidden
  });

export const createOrientationSettingsSchema = ({ title, info, value, isHidden }) =>
  createFieldSchema({
    component: 'OrientationSettings',
    title,
    info,
    value,
    isHidden
  });

export const createSelectSchema = ({ title, info, value, isHidden, props, staticProps }) =>
  createFieldSchema({
    type: 'select',
    title,
    info,
    value,
    isHidden,
    props,
    staticProps
  });

export const createNumberSchema = ({ title, info, value, isHidden, props }) =>
  createFieldSchema({
    type: 'number',
    title,
    info,
    value,
    isHidden,
    props
  });



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.PropsEditorGuiSchemaFunctions.js